module.exports = __webpack_public_path__ + "static/media/icon.aa8b5651.svg";